export const ROLES_REQUEST = 'roles/ROLES_REQUEST';
export const ROLES_SUCCESS = 'roles/ROLES_SUCCESS';
export const ROLES_FAILURE = 'roles/ROLES_FAILURE';
export const ROLE_REQUEST = 'roles/ROLE_REQUEST';
export const ROLE_SUCCESS = 'roles/ROLE_SUCCESS';
export const ROLE_FAILURE = 'roles/ROLE_FAILURE';
export const ROLE_SAVE_REQUEST = 'roles/ROLE_SAVE_REQUEST';
export const ROLE_SAVE_SUCCESS = 'roles/ROLE_SAVE_SUCCESS';
export const ROLE_SAVE_FAILURE = 'roles/ROLE_SAVE_FAILURE';
export const ROLE_UPDATE_REQUEST = 'roles/ROLE_UPDATE_REQUEST';
export const ROLE_UPDATE_SUCCESS = 'roles/ROLE_UPDATE_SUCCESS';
export const ROLE_UPDATE_FAILURE = 'roles/ROLE_UPDATE_FAILURE';
export const ROLE_DELETE_REQUEST = 'roles/ROLE_DELETE_REQUEST';
export const ROLE_DELETE_SUCCESS = 'roles/ROLE_DELETE_SUCCESS';
export const ROLE_DELETE_FAILURE = 'roles/ROLE_DELETE_FAILURE';
// new roles endpoints
export const PERMISSIONS_MACROS = 'roles/PERMISSIONS_MACROS';
